import React, { ReactElement } from 'react';
import { withRequireOnboarding } from 'src/components/withRequireOnboarding';
import { usePageTitle } from 'src/hooks/useMastheadTitle';
import DetectionPage from 'src/routes/detectionsV2/Main';

export default function DetectionRoute(): ReactElement {
	usePageTitle('Detections');
	const Page = withRequireOnboarding(DetectionPage);

	return <Page />;
}
